import { render } from "./TransferWallet.vue?vue&type=template&id=c6b905cc&scoped=true"
import script from "./TransferWallet.vue?vue&type=script&lang=js"
export * from "./TransferWallet.vue?vue&type=script&lang=js"

import "./TransferWallet.vue?vue&type=style&index=0&id=c6b905cc&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6b905cc"]])

export default __exports__